module.exports = __webpack_public_path__ + "img/19.66afd5c7.webp";